import styled from "styled-components";

export const MediaCarouselContainer = styled.div`
  max-width: 800px;
  width: calc(100% - 100px);
`;